import React, { useState, useEffect } from 'react';
import '../styles/styles.css';
import { Factory, Webcam, KeyRound, Hourglass, Handshake, Phone, Mail, User, DollarSignIcon, CreditCard, Coins, Calendar, RefreshCw, UserCheck } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import { createCustomerWithoutPayment } from '../api/UrlPayment.api';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { validateSalesCode } from '../../adminDashboard/api/salesCode.api.js';



interface FirstPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  // Renders inline inside the admin layout (back goes to /adminSales) instead of a full-screen overlay.
  embedded?: boolean;
}



const UrlPayments: React.FC<FirstPaymentModalProps> = ({ isOpen, onClose, onConfirm, embedded = false }) => {

  const [error, setError] = useState<string | null>(null);
  const [customerName, setCustomerName] = useState<string>('');
  const [cameraQuantity, setCameraQuantity] = useState<string>('');
  const [licenceType, setLicenceType] = useState<string>('');
  const [licenceExtension, setLicenceExtension] = useState<string>('');
  const [mainUserName, setMainUserName] = useState<string>('');
  const [mainUserEmail, setMainUserEmail] = useState<string>('');
  const [mainUserPhone, setMainUserPhone] = useState<string>('');
  const [amount, setAmount] = useState<number | null>(null);
  const [billingType, setBillingType] = useState<string>('mrr');
  const [mrrAmount, setMrrAmount] = useState<number>(0);
  const [oneshotAmount, setOneshotAmount] = useState<number>(0);
  const [softwareMonthsPaid, setSoftwareMonthsPaid] = useState<number>(0);
  const [isRenewal, setIsRenewal] = useState<boolean>(false);
  const [vendedor, setVendedor] = useState<string>('');
  const [salesPersonCode, setSalesPersonCode] = useState<string>('');

  const [blocked, setBlocked] = useState<boolean>(false);
  const [paymentStatus, setPaymentStatus] = useState<string>('');
  const [displayPaymentStatus, setDisplayPaymentStatus] = useState<boolean>(false);
  const [daysLeft, setDaysLeft] = useState<number>(0);
  const navigate = useNavigate();


  const location = useLocation();
  const has_100 = location.pathname.includes('_100');

  useEffect(() => {
    setPaymentStatus(has_100 ? '100_paid' : 'parcial_paid');
  }, [has_100]);

  //useEffect(() => {
  //  console.log("paymentStatus:", paymentStatus);
  //}, [paymentStatus]);


  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);


  const goToSalesTeam = () => {
    navigate(embedded ? '/adminSales' : '/sales');
  };

  const validatePhoneNumber = (phone: string): boolean => {
    // Expresión regular para el formato de teléfono (ej. +5491112345678 o 1112345678)
    // Permite un '+' opcional al inicio, seguido de 7 a 15 dígitos.
    // 7 es un mínimo común, 15 es el máximo recomendado por el estándar E.164.
    const phoneRegex = /^\+?[0-9]{7,15}$/; 
    return phoneRegex.test(phone);
  };




  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(mainUserEmail)) {
      toast.error("Por favor, ingrese un email válido. Debe tener el formato 'nombre@dominio.com'.");
      return;
    }

    if (!validatePhoneNumber(mainUserPhone)) {
      toast.error("Por favor, ingrese un número de teléfono válido. Debe contener el código de área, solo dígitos, y opcionalmente puede incluir el '+' al inicio. Ejemplo: +5491112345678.");
      return;
    }

    // Regla de montos según el tipo de cobro
    const finalMrrAmount = (billingType === 'mrr' || billingType === 'oneshot_mrr') ? mrrAmount : 0;
    const finalOneshotAmount = (billingType === 'oneshot' || billingType === 'oneshot_mrr') ? oneshotAmount : 0;

    if (salesPersonCode) {
      try {
        const validation = await validateSalesCode(salesPersonCode);
        if (!validation.valid) {
          setError("Código de comercial inválido.");
          toast.error("Código de comercial inválido.");
          return;
        }
      } catch (error) {
        setError("Código de comercial inválido.");
        toast.error("Código de comercial inválido.");
        return;
      }
    }

    // Nota: Se recomienda que el backend use updateDoc para evitar pisar datos del Health Monitor
    const formData = {
      customerName,
      cameraQuantity,
      licenceType,
      licenceExtension,
      mainUserName,
      mainUserEmail,
      mainUserPhone,
      amount,
      paymentStatus,
      daysLeft,
      salesPersonCode,
      billingType,
      mrrAmount: finalMrrAmount,
      oneshotAmount: finalOneshotAmount,
      softwareMonthsPaid,
      isRenewal,
      vendedor
    };



    toast.success("Configurando el cliente, por favor aguarde...", {
      position: "top-center",
      className: "toast-center"
    });


    console.log('Try with Form Data:', JSON.stringify(formData, null, 2));
    setBlocked(true);

    console.log("ok");  
    try {

      /*const configResponse = await new Promise((resolve) => {
        setTimeout(() => {
          console.log("Demo:", formData);
          resolve({ url: `/customerDashboard/12345/abcde` });
        }, 2000); 
      });
      */
     
      const configResponse = await createCustomerWithoutPayment(formData);
      if (configResponse && configResponse.url) {

        console.log("Navegando a:", configResponse.url);
        navigate(configResponse.url);

      } else {
        console.error("La respuesta de la API no contiene una URL de redirección.");
        toast.error("Error: La API no proporcionó una URL de pago.");
      }
      setBlocked(false);
    } catch (error) {
      console.error("Error al configurarr el cliente", error);
      toast.error("Hubo un error al configurar el cliente");
    }
  };




  return (
    <div className={embedded ? 'w-full' : 'w-full bg-green-400 py-3'}>
      <div className={embedded ? 'flex items-center justify-center' : 'fixed inset-0 bg-green-100 bg-opacity-50 flex items-center justify-center z-50'}>
        <div className="relative bg-white rounded-lg shadow-lg p-4 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
          <h2 className="text-lg font-semibold mb-4">Crea el cliente</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="confirmationPassword" className="block text-gray-700 text-sm font-bold mb-2">
                Coloca los datos del cliente, seleccione la cantidad de cámaras y período de licencia abonada:
              </label>
              <p className="text-sm text-gray-600">El monto debajo es el abonado.</p>
              <br />

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                            <label className="Label" htmlFor="salesPersonCode">Codigo personal del comercial</label>
                            <div className="InputWrapper">
                              <Handshake size={18} />
                              <input
                                className="Input"
                                type="text"
                                id="salesPersonCode"
                                name="salesPersonCode"
                                value={salesPersonCode}
                                onChange={(e) => setSalesPersonCode(e.target.value)}
                                placeholder="Ingresa tu código"
                                required
                              />
                            </div>
                          </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="customerName">Nombre de la empresa / Propietario</label>
                <div className="InputWrapper">
                  <Factory size={18} />
                  <input
                    className="Input"
                    type="text"
                    id="customerName"
                    name="customerName"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    placeholder="Empresa o Propietario"
                    required
                  />
                </div>
              </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="mainUserName">Nombre del dueño</label>
                <div className="InputWrapper">
                  <User size={18} />
                  <input
                    className="Input"
                    type="text"
                    id="mainUserName"
                    name="mainUserName"
                    value={mainUserName}
                    onChange={(e) => setMainUserName(e.target.value)}
                    placeholder="Nombre del dueño"
                    required
                  />
                </div>
              </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="billingType">Tipo de Cobro</label>
                <div className="SelectContainer">
                  <CreditCard size={18} />
                  <select
                    className="Select"
                    id="billingType"
                    name="billingType"
                    value={billingType}
                    onChange={(e) => setBillingType(e.target.value)}
                    required
                  >
                    <option value="mrr">MRR (Mensual)</option>
                    <option value="oneshot">One Shot (Pago único)</option>
                    <option value="oneshot_mrr">One Shot + MRR</option>
                  </select>
                </div>
              </div>

              {(billingType === 'mrr' || billingType === 'oneshot_mrr') && (
                <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                  <label className="Label" htmlFor="mrrAmount">Monto MRR</label>
                  <div className="InputWrapper">
                    <Coins size={18} />
                    <input
                      className="Input"
                      type="number"
                      id="mrrAmount"
                      value={mrrAmount}
                      onChange={(e) => setMrrAmount(parseFloat(e.target.value) || 0)}
                      placeholder="0.00"
                      required
                    />
                  </div>
                </div>
              )}

              {(billingType === 'oneshot' || billingType === 'oneshot_mrr') && (
                <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                  <label className="Label" htmlFor="oneshotAmount">Monto One Shot</label>
                  <div className="InputWrapper">
                    <Coins size={18} />
                    <input
                      className="Input"
                      type="number"
                      id="oneshotAmount"
                      value={oneshotAmount}
                      onChange={(e) => setOneshotAmount(parseFloat(e.target.value) || 0)}
                      placeholder="0.00"
                      required
                    />
                  </div>
                </div>
              )}

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="softwareMonthsPaid">Meses de software</label>
                <div className="InputWrapper">
                  <Calendar size={18} />
                  <input
                    className="Input"
                    type="number"
                    id="softwareMonthsPaid"
                    value={softwareMonthsPaid}
                    onChange={(e) => setSoftwareMonthsPaid(parseInt(e.target.value) || 0)}
                    required
                  />
                </div>
              </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="vendedor">Nombre del Vendedor</label>
                <div className="InputWrapper">
                  <UserCheck size={18} />
                  <input
                    className="Input"
                    type="text"
                    id="vendedor"
                    value={vendedor}
                    onChange={(e) => setVendedor(e.target.value)}
                    placeholder="Ej: Batman"
                    required
                  />
                </div>
              </div>

              <div className="FormGroup flex items-center gap-2" style={{ animationDelay: '0.1s', marginBottom: '1.5rem' }}>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isRenewal"
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                    checked={isRenewal}
                    onChange={(e) => setIsRenewal(e.target.checked)}
                  />
                  <label htmlFor="isRenewal" className="ml-2 text-sm font-medium text-gray-700 flex items-center gap-1">
                    <RefreshCw size={14} /> ¿Es una renovación?
                  </label>
                </div>
              </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="mainUserEmail">Email del dueño</label>
                <div className="InputWrapper">
                  <Mail size={18} />
                  <input
                    className="Input"
                    type="email"
                    id="mainUserEmail"
                    name="mainUserEmail"
                    value={mainUserEmail}
                    onChange={(e) => setMainUserEmail(e.target.value)}
                    placeholder="Email del dueño"
                    required
                    title="Ingrese una dirección de correo válida, con @ y ., ej: nombre@gmail.com"
                  />
                </div>
              </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="mainUserPhone">Teléfono del dueño</label>
                <div className="InputWrapper">
                  <Phone size={18} />
                  <input
                    className="Input"
                    type="text"
                    id="mainUserPhone"
                    name="mainUserPhone"
                    value={mainUserPhone} // Cambiamos esto para que el valor sea el estado limpio
                    onChange={(e) => {
                      const value = e.target.value.trim();
                      // Limpiamos el valor de espacios, guiones y paréntesis, pero mantenemos un '+' inicial
                      const cleanedValue = value.replace(/[\s\-\(\)]/g, ''); 
                      
                      // Aseguramos que solo haya un '+' al inicio, si existe.
                      let finalValue = cleanedValue;
                      if (cleanedValue.startsWith('+')) {
                        // Mantenemos el '+' inicial y luego removemos cualquier otro '+' del resto de la cadena.
                        finalValue = '+' + cleanedValue.substring(1).replace(/\+/g, '');
                      } else {
                        // Si no empieza por '+', nos aseguramos de que no haya ninguno.
                         finalValue = cleanedValue.replace(/\+/g, '');
                      }
                      
                      // Finalmente, solo permitimos dígitos después del posible '+' inicial.
                      finalValue = finalValue.replace(/[^\d+]/g, ''); // Remueve todo lo que no sea dígito o '+'
                      
                      setMainUserPhone(finalValue);
                    }}
                    placeholder="Ej: +5491112345678" // Cambia el placeholder para guiar al usuario
                    required
                  />
                </div>
              </div>



              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="cameraQuantity">Cantidad de cámaras físicas</label>
                <div className="SelectContainer">
                  <Webcam size={18} />
                  <select
                    className="Select"
                    id="cameraQuantity"
                    name="cameraQuantity"
                    value={cameraQuantity}
                    onChange={(e) => setCameraQuantity(e.target.value)}
                    required
                  >
                    <option value="" disabled>-- Selecciona la Cantidad de Cámaras --</option>
                    <option value={`1_cam_$`}>1 Cam</option>
                    <option value={`2_cam_$`}>2 Cam</option> //
                    <option value={`3_cam_$`}>3 Cam</option>
                    <option value={`4_cam_$`}>4 Cam</option> //
                    <option value={`5_cam_$`}>5 Cam</option> //
                    <option value={`6_cam_$`}>6 Cam</option>
                    <option value={`7_cam_$`}>7 Cam</option> //
                    <option value={`8_cam_$`}>8 Cam</option> //
                    <option value={`9_cam_$`}>9 Cam</option>
                    <option value={`10_cam_$`}>10 Cam </option> //
                    <option value={`11_cam_$`}>11 Cam </option> //
                    <option value={`12_cam_$`}>12 Cam </option>
                  </select>
                </div>
              </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="licenceType">Cantidad de Slots dentro del dashboard
</label>
                <div className="SelectContainer">
                  <KeyRound size={18} />
                  <select
                    className="Select"
                    id="licenceType"
                    name="licenceType"
                    value={licenceType}
                    onChange={(e) => setLicenceType(e.target.value)}
                    required
                  >
                    <option value="" disabled>-- Selecciona la Cantidad de Slots --</option>
                    <option value={`1_slot_lic_$`}>1 cámara</option>
                    <option value={`2_slot_lic_$`}>2 cámaras</option>
                    <option value={`3_slot_lic_$`}>3 cámaras</option>
                    <option value={`4_slot_lic_$`}>4 cámaras</option>
                    <option value={`5_slot_lic_$`}>5 cámaras</option>
                    <option value={`6_slot_lic_$`}>6 cámaras</option>
                    <option value={`7_slot_lic_$`}>7 cámaras</option>
                    <option value={`8_slot_lic_$`}>8 cámaras</option>
                    <option value={`9_slot_lic_$`}>9 cámaras</option>
                    <option value={`10_slot_lic_$`}>10 cámara</option>
                    <option value={`11_slot_lic_$`}>11 cámara</option>
                    <option value={`12_slot_lic_$`}>12 cámara</option>
                  </select>
                </div>
              </div>

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="daysLeft">Dias de contrato</label>
                <div className="InputWrapper">
                  <Hourglass size={18} />
                  <input
                    className="Input"
                    type="number"
                    id="daysLeft"
                    name="daysLeft"
                    value={daysLeft}
                    onChange={(e) => setDaysLeft(parseInt(e.target.value))}
                    required
                  >
                  </input>
                </div>
              </div>


              {/*<div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                <label className="Label" htmlFor="licenceExtension">Extencion de plazo anticipadamente</label>
                <div className="SelectContainer">
                  <Hourglass size={18} />
                  <select
                    className="Select"
                    id="licenceExtension"
                    name="licenceExtension"
                    value={licenceExtension}
                    onChange={(e) => setLicenceExtension(e.target.value)}
                    required
                  >
                    <option value="">Selecciona la extensión</option>
                    <option value="0_year">No extendida</option>
                    <option value={`1_year`}>1 año</option>
                    <option value={`2_year`}>2 años</option>
                    <option value={`3_year`}>3 años</option>
                  </select>
                </div>
              </div>*/}

              <div className="FormGroup" style={{ animationDelay: '0.1s' }}>
                            <label className="Label text-xl" htmlFor="salePrice"> <strong>Precio de venta</strong></label>
                            <div className="InputWrapper">
                              <DollarSignIcon size={18} />
                  <input
                    className="InputGreen"
                    type="number"
                     step="0.01"
                    min="0"
                    id="amount"
                    name="amount"
                    value={amount === null ? '' : amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      setAmount(value === '' ? null : parseFloat(value));
                    }}
                    placeholder="0000,00"
                    required
                  />
                </div>
              </div>

              {/*
            <button
              className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-300 rounded"
              onClick={(e) => {
                e.preventDefault();
                setDisplayPaymentStatus(!displayPaymentStatus);
              }}
            >
              {displayPaymentStatus ? '' : ''} Otras opciones
            </button>
            <br/>
            <br/>

            <div className={`${displayPaymentStatus ? '' : 'hidden'} select-container`}>
              <label className="Label" htmlFor="paymentStatus">Método de pago</label>
              <div className="SelectContainer">
                <select
                  className="Select"
                  id="paymentStatus"
                  name="paymentStatus"
                  value={paymentStatus}
                  onChange={(e) => setPaymentStatus(e.target.value)}
                  required
                >
                  <option value="">Selecciona una opción</option>
                  <option value="100_paid">Pago total</option>
                  <option value="parcial_paid">Pago parcial</option>
                </select>
              </div>
            </div>
            */}




              {/*<div className="mt-4">
                <p className="text-xs text-gray-500">
                  ¿Necesitás ayuda con el formulario? Podés contactarnos{" "}
                  <a
                    href="https://wa.link/dezljg"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    acá
                  </a>.
                </p>
              </div>*/}

              {/*<div className="mt-6 text-right border-t pt-4 border-gray-200">
                <p className="text-lg font-bold text-gray-800">
                  Total abonado: <span className="text-blue-600">U$D {(amount ?? 0).toFixed(2)}</span>
                </p>
              </div>
*/}

              <div className="flex justify-end gap-2 mt-6">
                <button
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={goToSalesTeam}
                >
                  Cancelar
                </button>
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex items-center justify-center"
                  type="submit"
                  disabled={blocked} // Deshabilita el botón si está bloqueado
                >
                  {blocked ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Cargando...
                    </>
                  ) : (
                    'Aceptar'
                  )}
                </button>
              </div>

            </div>
          </form>
          <ToastContainer />


        </div>
      </div>
    </div>
  );
};

export default UrlPayments;